<div class="loading-container">
  <img [src]="logoPath" class="rotating-image" alt="Loading" />
</div>